<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [colors]="chartOptions.colors!"
        [labels]="chartOptions.labels!"
        [stroke]="chartOptions.stroke!"
        [legend]="chartOptions.legend!"
        [grid]="chartOptions.grid!"
        [title]="chartOptions.title!"
        [dataLabels]="chartOptions.dataLabels!"
        [fill]="chartOptions.fill!"
        [tooltip]="chartOptions.tooltip!"
    ></apx-chart>
</div>